import Head from 'next/head';
import { useMemo } from 'react';

type Props = {
    articles: Array<any>;
};

export const ArticleListSchema = ({ articles }: Props) => {
    const preparedArticles: Array<any> = useMemo(() => {
        if (!articles) {
            return [];
        }
        return articles.map((item, i) => ({
            '@type': 'ListItem',
            position: i,
            item: {
                '@type': 'NewsArticle',
                headline: item?.pageTitle,
                datePublished: item?.creationDate,
                author: {
                    '@type': 'Person',
                    name: item?.createdBy,
                },
            },
        }));
    }, [articles]);

    // https://www.hillwebcreations.com/valid-image-size-json-ld-snippet-markup/#:~:text=%E2%80%9CImages%20must%20be%20at%20least,most%201920%C3%971080%20pixels.
    return (
        <Head>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: `
            {
                "@context":"https://schema.org",
                "@type":"ItemList",
                "itemListElement": ${JSON.stringify(preparedArticles)}
            }
             `,
                }}
            >
                {}
            </script>
        </Head>
    );
};
